<template>
    <!-- <div>  	   -->
    <b-form-group
        :label="labelId"
        :class="{
            // 'required-field': !!identityInfoType,
        }"
        label-for="inputId"
    >
        <b-form-file
            ref="file-input"
            v-model="model"
            v-validate="{
                // required: !!identityInfoType,
            }"
            input-id="licenseBack"
            :placeholder="
                originalFileName || 'Select scan copy (JPG, PNG, PDF or TIFF file)'
            "
            drop-placeholder="Drop file here..."
            file-type="licenseBack"
            accept="image/*,application/pdf"
            :disabled="!identityInfoType"
            data-vv-name="License document back scan copy"
            :class="{
                'is-invalid': errors.has('License document back scan copy'),
                // 'required-field': !!identityInfoType,
            }"
            @input="uploadImage"
        ></b-form-file>
        <b-modal
            fileType="this.fileType"
            ref="modal"
            size="lg"
            title="License Document Back"
            :click-to-close="false"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            @close="onHidden"
        >

           <div 
                   v-if="fileType!=='application/pdf'"
                   @click="rotateImage"
                   class="custom-rotate"
                   >
				<img :src="require('@/assets/reset.png')" 
                 >
			</div>
            <cropper
                v-if="this.fileType!=='application/pdf'"
                ref="cropper"
                :src="image"
                class="upload-example-cropper"
            ></cropper>
            <label v-else >
                Would you like to continue without document validation ?
            </label>
            <!-- <button v-on:click="rotateImage">Rotate Image</button> -->
            <template #modal-footer="{}">
                <b-button size="sm" style="background-color: azure;color: rgb(101, 26, 152);" @click="onHidden">
                    Cancel
                </b-button>
                <b-button size="sm" variant="primary" @click="crop">
                    Continue
                </b-button>
            </template>
        </b-modal>
    </b-form-group>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import TextField from './TextField'
import request from '@/utils/request'

export default {
    // End of Component > watch

    components: {
        Cropper,
    },
    extends: TextField, // End of Component > inject

    props: {
        field: {
            type: Object,
            default() {
                return {
                    isRequired: true,
                    isLocked: true,
                    key: 'documentInfo.licenseBack.fileName',
                    originalFileNameKey:
                        'documentInfo.licenseBack.originalFileName',
                }
            },
            required: false,
        },
    }, // End of Component > props
    data() {
        return {
            image: '',
            selectedFileName: '',
            fileType: '',
        }
    }, // End of Component > Data
    computed: {
        identityInfoType() {
            return this.$store.getters.getField('identityInfo.type')
        },
        originalFileName() {
            return this.$store.getters.getField(this.field.originalFileNameKey)
        },
        labelId() {
            return 'LICENSE DOCUMENT BACK SCAN COPY'
        },
    },
    watch: {},
    inject: {
        $validator: '$validator',
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {},
    methods: {
        onHidden() {
            this.$refs['file-input'].reset()
            // console.log('modal-hide-start')
            this.$refs.modal.hide()
            this.$store.commit('updateField', {
                key: this.field.key,
                value: null,
            })
            this.updateOriginalFileName(null)

            // console.log('modal-hide-finsih')
        },
        rotateImage() {
            var image = document.createElement('img')
            image.crossOrigin = 'anonymous'
            image.src = this.image
            image.onload = () => {
                var canvas = document.createElement('canvas')
                var ctx = canvas.getContext('2d')

                /**
                 * Rotating Image 90 degrees
                 */
                if (image.width > image.height) {
                    canvas.width = image.height
                    canvas.height = image.width
                    ctx.translate(image.height, image.width / image.height)
                } else {
                    canvas.height = image.width
                    canvas.width = image.height
                    ctx.translate(image.height, image.width / image.height)
                }
                ctx.rotate(Math.PI / 2)
                ctx.drawImage(image, 0, 0)

                // /**
                //  * Rotating Image 180 Degrees */
                // canvas.width = image.width;
                // canvas.height = image.height;
                // ctx.translate(canvas.width / 2,canvas.height / 2);
                // // Rotate the image and draw it on the canvas.
                // 	// (I am not showing the canvas on the webpage.
                // ctx.rotate(Math.PI);
                // ctx.drawImage(image, -image.width / 2, -image.height / 2);

                this.image = canvas.toDataURL()
            }
        },
        updateOriginalFileName(newValue) {
            // console.log('New Values: ' + newValue)
            // console.log('New Values: ' + this.field.originalFileNameKey)
            this.$store.commit('updateField', {
                key: this.field.originalFileNameKey,
                value: newValue,
            })
        },
        change({ coordinates, canvas }) {
            // console.log(coordinates, canvas)
        },
        crop() {
            // console.log(this.$refs)
            // const { coordinates, canvas, } = this.$refs.cropper.getResult();
            if(this.fileType!=='application/pdf'){
                const result = this.$refs.cropper.getResult()
                this.image = result.canvas.toDataURL()
            }
            // console.log(result)
            // this.coordinates = coordinates;
            // You able to do different manipulations at a canvas
            // but there we just get a cropped image, that can be used
            // as src for <img/> to preview result
            
            // Split the base64 string in data and contentType
            var block = this.image.split(';')
            // Get the content type of the image
            var contentType = block[0].split(':')[1] // In this case "image/gif"
            // get the real base64 content of the file
            var realData = block[1].split(',')[1] // In this case "R0lGODlhPQBEAPeoAJosM...."
            // Convert it to a blob to upload
            var blob = this.b64toBlob(realData, contentType)

            var file = new File([blob], this.selectedFileName)
            // console.log(file)
            // this.onFileInput(file)
            this.fileCompressor(file)
            this.$refs.modal.hide()
        },
        uploadImage(file) {
            // console.log('UploadImageType: ' + file.type)
            // Reference to the DOM input element
            // var input = event.target;
            // // Ensure that you have a file before attempting to read it
            if (file) {
                if (
                    file.type === 'image/jpeg' ||
                    file.type === 'image/jpg' ||
                    file.type === 'image/png' ||
                    file.type === 'application/pdf'
                ) {
                    // console.log('UploadImage: ' + file)
                    this.updateOriginalFileName(file.name)
                    this.selectedFileName = file.name
                    this.fileType = file.type
                    // console.log(
                    //     'selectedFileName: ' + this.selectedFileName,
                    //     this.fileType
                    // )
                    // create a new FileReader to read this image and convert to base64 format
                    var reader = new FileReader()
                    // Define a callback function to run, when FileReader finishes its job
                    reader.onload = (e) => {
                        // console.log(e)
                        // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                        // Read image as base64 and set to imageData
                        this.image = e.target.result
                        this.$refs.modal.show()
                    }
                    // Start the reader job - read file as a data url (base64 format)
                    reader.readAsDataURL(file)
                } else {
                    this.onHidden()
                    this.$store.commit('setError', 'File format not supported')
                }
            }
        },
        async onFileInput(file) {
            // console.log('File: ' + file)
            if (file) {
                this.$store.commit('setLoading', true)
                try {
                    const formData = new FormData()

                    formData.append('type', 'identity')
                    formData.append('file', file, file.name)

                    const headers = {
                        'Content-Type': 'multipart/form-data',
                    }
                    const { data } = await request.post(
                        'files/encrypt',
                        formData,
                        {
                            headers,
                        }
                    )

                    // console.log('FileName: ' + data.data.fileName)
                    // console.log('FileName: ' + file.name)
                    setTimeout(() => {
                        this.$store.commit('updateField', {
                            key: this.field.key,
                            value: data.data.fileName,
                        })

                        this.$emit('input', data.data.fileName)
                        this.updateOriginalFileName(file.name)
                        this.$store.commit('setLoading', false)
                    }, 3000)
                } catch (error) {
                    // console.log(error)
                    this.$store.commit('setLoading', false)
                }
                
            }
        },
        encrypt(input) {
            // console.log(input)
            var file = input
            var reader = new FileReader()
            reader.onload = () => {
                // var key = process.env.VUE_APP_CRYPTO_SECERT_KEY
                var wordArray = this.CryptoJS.lib.WordArray.create(
                    reader.result
                ) // Convert: ArrayBuffer -> WordArray
                var encrypted = this.$encrypt(wordArray,false) // Encryption: I: WordArray -> O: -> Base64 encoded string (OpenSSL-format)

                var fileEnc = new Blob([encrypted]) // Create blob from string
                var filename = file.name + '.enc'
                const myFile = new File([fileEnc], filename, {
                    type: fileEnc.type,
                })

                this.onFileInput(myFile)
            }
            reader.readAsArrayBuffer(file)
            // console.log(file)
        },
        fileCompressor(input) {
            var file = input

            console.log('File Size', file.size)

            if (file.size >= 1000000) {
                console.log('1 MB Image')

                var readerImage = new FileReader()
                readerImage.readAsDataURL(file)

                readerImage.onload = (event) => {
                    const imgElement = document.createElement('img')
                    imgElement.src = event.target.result
                    // document.querySelector("#input").src = event.target.result;
                    console.log('imgElement.src')
                    console.log('Input', input)
                    imgElement.onload = (e) => {
                        const canvas = document.createElement('canvas')
                        const MAX_WIDTH = 600

                        const scaleSize = MAX_WIDTH / e.target.width
                        canvas.width = MAX_WIDTH
                        canvas.height = e.target.height * scaleSize

                        const ctx = canvas.getContext('2d')

                        ctx.drawImage(
                            e.target,
                            0,
                            0,
                            canvas.width,
                            canvas.height
                        )

                        const srcEncoded = ctx.canvas.toDataURL(
                            e.target,
                            'image/jpeg'
                        )

                        console.log('srcEncoded', srcEncoded)
                        // file = dataURLtoFile([srcEncoded] , file.name , file.type  )
                        var arr = srcEncoded.split(','),
                            mime = arr[0].match(/:(.*?);/)[1],
                            bstr = atob(arr[1]),
                            n = bstr.length,
                            u8arr = new Uint8Array(n)

                        while (n--) {
                            u8arr[n] = bstr.charCodeAt(n)
                        }

                        const fileConverted = new File([u8arr], file.name, {
                            type: mime,
                        })
                        console.log('FIle Converted', fileConverted)

                        this.encrypt(fileConverted)
                    }
                }
            } else {
                console.log('Image Below 1 mb')
                this.encrypt(file)
            }
        },
        b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || ''
            sliceSize = sliceSize || 512

            var byteCharacters = atob(b64Data)
            var byteArrays = []

            for (
                var offset = 0;
                offset < byteCharacters.length;
                offset += sliceSize
            ) {
                var slice = byteCharacters.slice(offset, offset + sliceSize)

                var byteNumbers = new Array(slice.length)
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i)
                }

                var byteArray = new Uint8Array(byteNumbers)

                byteArrays.push(byteArray)
            }

            var blob = new Blob(byteArrays, { type: contentType })
            return blob
        },
    }, // End of Component > mounted
}
</script>

<style>
.upload-example-cropper {
    border: solid 1px #eee;
    height: 350px;
    width: 100%;
}

.custom-rotate{
    position:absolute;
    z-index: 1;
    width: 50px;
    height: 50px;
}
</style>
